import React, { PureComponent, Fragment } from 'react';
import { withTranslation } from 'react-i18next';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Picture } from 'formlabs-web-components/Media';
import { Button, Link } from 'formlabs-web-components/Link';
import CenterModal from '../modal/CenterModal';
import blackIcon from '../../../../public/play_black.svg';
import whiteIcon from '../../../../public/play_white.svg';

import './YoutubeModal.module.css';
const YoutubeModal = DisplayComponent(
  class YoutubeModal extends PureComponent {
    state = {
      open: false
    };
    handleLinkClick = e => {
      this.setState({ open: true });
    };
    handleClose = () => {
      this.setState({ open: false });
    };
    render() {
      const {
        videoUrl,
        videoThumb,
        videoThumbAlt,
        linkDisplay,
        buttonText,
        buttonColor,
        fullBleedImage,
        playIcon,
        t
      } = this.props;
      return (
        <Fragment>
          {linkDisplay === 'text' && (
            <Button
              type="button"
              color="inherit-color"
              onClick={this.handleLinkClick}
            >
              {buttonText}
            </Button>
          )}
          {linkDisplay === 'button' && (
            <Button
              type="button"
              color={buttonColor}
              onClick={this.handleLinkClick}
            >
              <div styleName="button-fix">
                <i
                  className={
                    buttonColor === 'light' ? `fl-play-icon` : `fl-play-white`
                  }
                  styleName="icon"
                >
                  <span className="path1" />
                  <span className="path2" />
                </i>
                {buttonText}
              </div>
            </Button>
          )}
          {linkDisplay === 'image' && (
            <div styleName="image-container">
              <button
                type="button"
                styleName="full-width"
                onClick={this.handleLinkClick}
                aria-label={t('Open youtube video in a modal')}
              >
                {playIcon === 'black' && (
                  <div styleName="play-container">
                    <Picture
                      largeImage={blackIcon}
                      alt={t('youtube play icon')}
                    />
                  </div>
                )}
                {playIcon === 'white' && (
                  <div styleName="play-container">
                    <Picture
                      largeImage={whiteIcon}
                      alt={t('youtube play icon')}
                    />
                  </div>
                )}
                <Picture
                  largeImage={videoThumb}
                  fullBleed={fullBleedImage}
                  alt={videoThumbAlt}
                />
              </button>
            </div>
          )}
          {this.state.open ? (
            <CenterModal
              id={videoUrl}
              onClose={this.handleClose}
              noPadding
              width="80vw"
            >
              <div styleName="responsive-video">
                <iframe
                  title="Youtube Modal"
                  src={videoUrl}
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </CenterModal>
          ) : null}
        </Fragment>
      );
    }
  }
);

export default withTranslation()(YoutubeModal);
